import api from "@/services/api";

export interface TransactionDetailsType {
  id: string;
  value: number;
  franchiseValue: number;
  franchiseAssociateValue?: number;
  status: string;
  createdAt: string;
  paymentMethod?: string;
  partnerDocument: string;
  partnerName: string;
  customer?: {
    name?: string;
    document?: string;
    email?: string;
    phone?: string;
  };
  partner?: {
    name?: string;
    document?: string;
    email?: string;
    phone?: string;
    cityName?: string;
    state?: string;
  };
}

class GetTransactionDetails {
  execute = async (transactionId: string) => {
    const response = await api().get(`/transaction/${transactionId}`);
    return response.data as TransactionDetailsType;
  };
}

export { GetTransactionDetails };
